<template>
    <modal closeMutation="SET_SHOP_SUCCESS_MODAL">
        <div class="modal_shop_success">
            <div class="modal_shop_success-icon">
                <img src="../../assets/img/thumb.png">
            </div>
            <div class="modal_shop_success-title">
                Спасибо!
            </div>
            <div class="modal_shop_success-text">
                {{text}}
            </div>
            <div class="modal_shop_success-data" v-if="this.data.method !== 'credit'">
                <div class="modal_shop_success-data_price">
                    - <currency-symbol :price="price"/>
                </div>
                Данные будут отображаться
                в вашем личном кабинете.
            </div>
            <div class="modal_shop_success-btn btn btn-full btn-square" @click="this.$router.push({'name': 'Items'})">
                Перейти в личный кабинет
            </div>
        </div>
    </modal>
</template>

<script>
    import Modal from "../../views/Modal";
    import CurrencySymbol from "../CurrencySymbol";

    export default {
        name: "ShopModalSuccess",
        components: {Modal, CurrencySymbol},
        computed: {
            data: function () {
                return this.$store.getters.shopSuccessModal
            },
            text: function () {
                if (this.data.method === 'cash'){
                    return 'Вы сможете оплатить заказ наличными в клубе.'
                } else if (this.data.method === 'credit'){
                    return 'Вы были направлены на страницу оформления заявки. Статус рассмотрения заявки вы можете уточнить в банке.'
                } else{
                    return 'Вы оплатили '+ this.data.name +'.'
                }
            },
            price: function () {
                return this.data.price
            }
        }
    }
</script>

<style src="@vueform/toggle/themes/default.css"></style>